import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { NAV_LINKS, LOGOS } from '../mock';

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur border-b border-slate-200 shadow-sm' : 'bg-white/90 backdrop-blur border-b border-white/40 shadow-sm'}`}>
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center" aria-label="Inżynieria Elektryczna Adrian Nowak">
          <img
            src={LOGOS.horizontal}
            alt="Inżynieria Elektryczna Adrian Nowak"
            className="h-11 md:h-12 w-auto"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[14px] font-medium text-[#0f1a2b]/80 hover:text-[#0f1a2b] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a href="#kontakt" className="hidden lg:inline-flex items-center gap-2 bg-[#f5c518] hover:bg-[#eab308] text-[#0f1a2b] font-semibold text-[14px] px-5 py-3 rounded-full transition-colors">
          Zapytaj o współpracę
        </a>

        <button className="lg:hidden text-[#0f1a2b]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-[15px] py-2 text-[#0f1a2b]">{l.label}</a>
            ))}
            <a href="#kontakt" onClick={() => setOpen(false)} className="mt-2 text-center bg-[#f5c518] text-[#0f1a2b] font-semibold px-5 py-3 rounded-full">Zapytaj o współpracę</a>
          </div>
        </div>
      )}
    </header>
  );
}
